import styled from 'styled-components';
import { WegetAnalysisVersionTabs } from './wegets/weget-analysis-version-tabs';
import { WegetSettingVariables } from './wegets/weget-setting-variables';
import { WegetTable } from './wegets/weget-table';

const StyledContainer = styled.div`
    background-color: var(--backgroundField);
    min-height:100vh;
    padding-bottom: 200px;
`;

export function MainView(props) {

    return (
        <>
            <StyledContainer>
                <WegetAnalysisVersionTabs />
                <WegetSettingVariables />
                <WegetTable />
            </StyledContainer>
        </>
    );
}
